import generic from './generic'

const getDefaultState = () => {
  return {
    all: [],
    errored: false,
    loading: false,
    fetchedAt: null,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {url: '/alliance/invitecode/'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {url: '/alliance/invitecode/', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
  available (state) {
    return state.all.filter(obj => !obj.invitee)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
